<template>
  <v-combobox
    v-model="myTags"
    class="tag-box"
    :items="items"
    :label="label"
    :hint="hint"
    multiple
    :disabled="disabled"
    :loading="loading"
    :hide-details="hideDetails"
  >
    <template v-slot:selection="data">
      <v-chip
        :key="JSON.stringify(data.item)"
        v-bind="data.attrs"
        label
        small
        outlined
        class="pr-2"
      >
        <span>{{ data.item }}</span>
        <v-icon class="tag-box-close-icon" size="11" @click="deleteTag(data.item)">
          mdi-close
        </v-icon>
      </v-chip>
    </template>
  </v-combobox>
</template>

<script>
const { getSummary } = require('@/lib/api')

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    group: {
      type: null,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    hint: {
      type: String,
      default: '',
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      myTags: [],
      items: [],
    }
  },
  watch: {
    myTags: {
      handler() {
        if (!this.myTags) return
        if (JSON.stringify(this.myTags) === JSON.stringify(this.value)) return
        this.$emit('input', this.myTags)
      },
      deep: true,
    },
    value: {
      handler() {
        this.myTags = JSON.parse(JSON.stringify(this.value))
      },
      immediate: true,
    },
  },
  created() {
    this.init()
  },
  methods: {
    updateTags() {
      this.init()
    },
    async init() {
      this.loading = true
      const tagSummmary = await getSummary({ type: 'tags', queryString: { group: this.group } })
      this.items = tagSummmary.data
      this.loading = false
    },
    deleteTag(tag) {
      this.$set(
        this,
        'myTags',
        this.myTags.filter((item) => {
          return item !== tag
        })
      )
    },
  },
}
</script>

<style lang="scss">
.tag-box {
  .tag-box-close-icon {
    margin-left: 3px;
  }
  .v-select__selections {
    margin-bottom: 0px !important;
  }
}
</style>
